import { FolderOpen } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { GENERAL_FOLDER_NAME } from '@/components/documents/fundDocumentFolders';
import { DocumentRow } from './DocumentRow';
import type { PortalDocument } from '../services/documents-service';

interface GeneralDocumentSectionProps {
  documents: PortalDocument[];
  onDownload: (documentId: string, filename: string) => void;
  downloadingId: string | null;
}

/** Documents that belong to the investor but to no fund, e.g. KYC. */
export function GeneralDocumentSection({
  documents,
  onDownload,
  downloadingId,
}: GeneralDocumentSectionProps) {
  return (
    <Card>
      <div className="flex items-center gap-3 p-4">
        <FolderOpen className="h-4 w-4 text-muted-foreground flex-shrink-0" />
        <span className="font-medium text-foreground">
          {GENERAL_FOLDER_NAME}
        </span>
        <span className="text-sm text-muted-foreground ml-auto">
          {documents.length} {documents.length === 1 ? 'document' : 'documents'}
        </span>
      </div>
      <CardContent className="pt-0 pb-3">
        {documents.map((doc) => (
          <DocumentRow
            key={doc.id}
            document={doc}
            onDownload={onDownload}
            isDownloading={downloadingId === doc.id}
          />
        ))}
      </CardContent>
    </Card>
  );
}
